import React from "react";
import {f_101_formatDateExactly} from "../DevServices/service_functions"

/* 
const options = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false
};

const date = new Date("2025-02-17T05:50:00.000Z");
console.log(date.toLocaleString('en-US', options));
*/
const LogList = (props) => {
  const {rx_log_list} = props
  if (!rx_log_list || rx_log_list.length === 0) return null;

  //console.log(rx_log_list)
  return (
    <>
    {/* <p>Hello from ActionList</p> */}
    <DataTable data = {rx_log_list} />
    </>
  )
}

export default LogList;

const DataTable = ({ data }) => {
  if (!data || data.length === 0) {
      return <p>No data available</p>;
  }

  return (
    <div className="container mt-5">
    <h2>Log records</h2>
    <table className="table table-striped">
        <thead>
            <tr>
                <th>ID</th>
                {/* <th>Dev ID</th> */}
                <th>Type</th>
                <th>Note</th>
                <th>Data Created</th>
            </tr>
        </thead>
        <tbody>
            {data.map((item) => (
                <tr key={item.id}>
                    <td>{item.id}</td>
                    {/* <td>{item.dev_id}</td> */}
                    <td>{item.type}</td>
                    <td>{item.note}</td>
                    {/* <td>{new Date(item.date_created).toLocaleString()}</td> */}
                    <td>{f_101_formatDateExactly(item.date_created)}</td>
                </tr>
            ))}
        </tbody>
    </table>
</div>
  );
};
/* 
function formatDateExactly(isoString) {
  const date = new Date(isoString);
  const pad = num => String(num).padStart(2, '0');
  
  return `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())}, ` +
         `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
} */